import NavComp from "../../SubComponents/NavCompo/NavComp";
import "./NavbarStyle.css";
import { NavData } from "../../Utils/localdata";
import Button from "../../SubComponents/Button/Button";
import { motion } from "framer-motion";
import { ScreenContext } from "../../Utils/contexts";
import { useContext } from "react";
export default function Navbar() {
  const { isLaptop } = useContext(ScreenContext);
  return (
    <div className='navbar' data-aos='fade-up'>
      <img src='./logo.png' className='logo-div' alt='logo' />

      {isLaptop && (
        <div className='navbar-menu'>
          {NavData.map((value, index) => {
            return <NavComp value={value} key={index} index={index} />;
          })}
        </div>
      )}
      <motion.div whilehover={{ scale: 1.1 }} whiletap={{ scale: 0.9 }} className='resume'>
        <a href={"/Resume.pdf"} download>
          <Button>Resume</Button>
        </a>
      </motion.div>
    </div>
  );
}
